import { ITypo } from '@/types/Typo'

const Description: React.FC<ITypo> = ({
  children,
  className = '',
  color = 'text-dark',
  weight = 'font-normal',
}) => {
  return (
    <p
      className={`${className} ${color} ${weight} hr:text-lg desktop:text-[20px] desktop:leading-6 laptop:text-[17px] laptop:leading-5 text-tiny`}
    >
      {children}
    </p>
  )
}

export default Description
